import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Session, Identity } from '@/lib/api/kratos';

/**
 * Auth store state - simplified like Nuxt2
 */
interface AuthState {
  session: Session | null;
  user: Identity | null;
  isAuthenticated: boolean;
  setSession: (session: Session) => void;
  clearSession: () => void;
}

/**
 * Zustand store for authentication state
 * Mimics Nuxt2 auth store behavior - simple and straightforward
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      user: null,
      isAuthenticated: false,
      setSession: (session) => {
        // Simple like Nuxt2: set user and isAuthenticated based on session
        set({
          session,
          user: session.identity,
          isAuthenticated: !!session.identity, // Like Nuxt2: !!user
        });
      },
      clearSession: () => {
        set({
          session: null,
          user: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        session: state.session,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        // Rehydration complete
      },
    }
  )
);
